import { Box } from '@mui/material'
import { Drawer, Loader } from 'packages/eid-ui'
import ItemHeader from '../ItemHeader'
import { isNilOrEmpty, useIsSmallScreen } from 'packages/core'
import ItemsDetailsMobileWrapper from 'components/ItemsDetailsMobileWrapper'
import ComputerDetails from './ComputerDetails'
import { useComputer } from 'hooks'
import { useTargetPerson } from 'hooks'
import { catalogDetailsDrawerExplainProps } from '../catalogDetailsDrawerExplain'

const ComputerDrawer = ({ id, toggleDrawer, attributes }) => {
    const isSmallScreen = useIsSmallScreen()
    const [targetPerson] = useTargetPerson()

    const { data: computer } = useComputer(id, targetPerson.id)

    return isSmallScreen ? (
        <ItemsDetailsMobileWrapper toggleDrawer={toggleDrawer}>
            <Box {...catalogDetailsDrawerExplainProps('computer')}>
                <ItemHeader title={computer?.friendlyName} />
                {!computer && <Loader />}
                {computer && (
                    <ComputerDetails
                        computer={computer}
                        toggleDrawer={toggleDrawer}
                        attributes={attributes}
                    />
                )}
            </Box>
        </ItemsDetailsMobileWrapper>
    ) : (
        <Drawer
            width="clamp(67%, 1007px, 90%)"
            open={!isNilOrEmpty(id)}
            toggleDrawer={toggleDrawer}
            stickyHeader
            closeOnOutsideClick
            header={<ItemHeader title={computer?.friendlyName} />}
        >
            <Box {...catalogDetailsDrawerExplainProps('computer')}>
                {!computer && <Loader />}
                {computer && (
                    <ComputerDetails
                        computer={computer}
                        toggleDrawer={toggleDrawer}
                    />
                )}
            </Box>
        </Drawer>
    )
}

export default ComputerDrawer
